
import React, { Component } from "react";
import Lottie from "lottie-react";
import animationJson from "./sun.json";

export interface SunAnimationProps
{
}

interface SunAnimationState 
{
}

export class SunAnimation extends Component<SunAnimationProps, SunAnimationState>
{
    constructor(props: SunAnimationProps)
    {
        super(props);

        this.state = {
        };
    }

    public render(): JSX.Element
    {
        return (
            <Lottie animationData={animationJson} loop={true} />
        );
    }
}